<template>
  <!-- 查询详情页 -->
  <div class="queryDetails"
       :style="{
      '--header_fontsize':
        (pageinfo.header_fontsize ? pageinfo.header_fontsize : 14) + 'px',
      '--header_isbold': pageinfo.header_isbold ? 'bold' : 'unset'
    }">
    <van-nav-bar :left-text="
        titleDate
          ? pageinfo.modulename + '(' + titleDate + ')'
          : pageinfo.modulename
      "
                 class="common_query_title"
                 left-arrow
                 @click-left="onClickLeft">
      <template #right>
        <van-tag v-if="branchName"
                 closeable
                 size="medium"
                 type="success"
                 @close="closeBranch">
          {{ branchName }}
        </van-tag>
        <van-icon v-if="pageinfo.can_query_branch_record"
                  name="friends-o"
                  size="18"
                  color="#ffffff"
                  style="margin-right: 6px"
                  @click="showBranch" />
        <van-icon v-if="pageinfo.appdatequery"
                  name="search"
                  size="18"
                  color="#ffffff"
                  style="margin-left: 6px"
                  @click="showCalendar = true" />
      </template>
    </van-nav-bar>
    <div class="overflow_div"
         :style="overflowStyle">
      <!-- 查询条件--日期 -->
      <div class="date_content"
           v-if="showYears || showMonths || showDates">
        <div v-if="showYears"
             class="year_box">
          <div class="icon_box"
               @click="arrowsYear('left')">
            <van-icon name="arrow-left" />
          </div>
          <div class="year_btn"
               v-for="(it, idx) in years"
               :key="idx"
               :class="[
              1 == 1 ? 'cao' + idx : '',
              checkedYear == it ? 'checkd_year' : ''
            ]"
               @click="getOneYear(it)">
            <div class="year">{{ it + '年' }}</div>
          </div>
          <div class="icon_box"
               @click="arrowsYear('right')">
            <van-icon name="arrow" />
          </div>
        </div>
        <div v-if="showMonths"
             class="month_box">
          <div class="month_btn"
               v-for="(it, idx) in months"
               :key="idx">
            <div class="month"
                 :class="checkedMonth == it ? 'checkd_Month' : ''"
                 @click="getOneMonth(it)">
              {{ it + '月' }}
            </div>
          </div>
        </div>
        <div v-if="showDates"
             class="date_box">
          <div class="head_date">
            <div class="icon_box"
                 @click="arrowDates('left')">
              <van-icon name="arrow-left" />
            </div>
            <div class="date_box"
                 v-for="(it, idx) in weeks"
                 :key="idx"
                 @click="getOneDay(it)">
              <div class="week">{{ it.week }}</div>
              <div class="date">
                <div class="text"
                     :class="checkdate == it.date ? 'bgtext' : ''">
                  {{ it.date }}
                </div>
              </div>
            </div>
            <div class="icon_box"
                 @click="arrowDates('right')">
              <van-icon name="arrow" />
            </div>
            <div class="icon_box"
                 @click="showCalendar = true">
              <van-icon name="calendar-o" />
            </div>
          </div>
          <van-calendar v-model="showCalendar"
                        :min-date="new Date(2010, 0, 1)"
                        @confirm="onConfirm"
                        style="z-index:10000" />
        </div>
      </div>
      <!-- 表格内容区 -->
      <div v-if="showTable"
           id="cq_tableContainer"
           class="table_content"
           :style="tabStyle">
        <van-search v-model="searchVal"
                    placeholder="请输入搜索关键词"
                    @input="onSearch"
                    style="height:55px" />
        <ve-table :columns="thList"
                  border-y
                  :table-data="tableData"
                  :footer-data="totalData"
                  :scrollWidth="scrollWidth"
                  :style="
            tableData.length == 0
              ? 'height:100px;'
              : 'height:calc(100% - 55px);' + 'width:100%;word-break:break-word'
          "
                  max-height="100%"
                  :cell-span-option="cellSpanOption"
                  :cell-style-option="cellStyleOption" />
        <div v-show="tableData.length == 0"
             class="empty-data"
             style="font-size:16px;text-align: center">
          暂无数据
        </div>
      </div>
      <!-- 表单内容区 -->
      <div v-if="showForm"
           class="form_content"
           :style="formStyle">
        <div class="userInfoRight"
             v-if="formValue.is_wxsign">
          <div class="svg_sigin">
            <svg-icon v-if="moduleno == 730"
                      icon-class="zu820"></svg-icon>
            <svg-icon v-else
                      icon-class="yiquren"></svg-icon>
          </div>
        </div>
        <!-- 不分组表单 -->
        <div class="noGroup_box"
             v-if="noGroupForm.length > 0">
          <div class="noGroup_form">
            <div class="peField"
                 v-for="(it, idx) in noGroupForm"
                 :key="idx">
              <!-- 不可编辑的输入框（除开关类型和文本域） -->
              <!-- <van-field v-if="it.fielddatatype != 'bit'"
                         :label="it.chnname"
                         v-model="formValue[it.fieldname]"
                         readonly /> -->
              <van-cell v-if="it.fielddatatype != 'bit'"
                        :title="it.chnname"
                        :value="formValue[it.fieldname]" />
              <!-- 不可编辑的开关 -->
              <van-field v-else
                         name="switch"
                         class="not_canedi"
                         :label="it.chnname">
                <template #input>
                  <van-switch v-model="formValue[it.fieldname]"
                              disabled
                              size="20" />
                </template>
              </van-field>
            </div>
          </div>
        </div>
        <!-- 分组表单 -->
        <van-collapse v-model="activeNames"
                      :style="collapseStyle">
          <van-collapse-item v-for="(item, index) in groupForm"
                             :key="index"
                             :name="index">
            <template #title>
              <div class="title_bg">
                <img :src="require('@assets/img/form_title.png')"
                     alt="" />
              </div>
              <div class="xiba_title">
                <van-icon :name="
                    require('@assets/img/ft_ico_' +
                      (index < 9 ? index + 1 : 9) +
                      '.png')
                  " />
                <div>{{ item.name }}</div>
              </div>
            </template>
            <div class="peField"
                 v-for="(it, idx) in item.origin"
                 :key="idx">
              <!-- 不可编辑的输入框（除开关类型和文本域） -->
              <!-- <van-field v-if="it.fielddatatype != 'bit'"
                         class="not_canedi"
                         :label="it.chnname"
                         v-model="formValue[it.fieldname]"
                         readonly /> -->
              <van-cell v-if="it.fielddatatype != 'bit'"
                        class="not_canedi"
                        :title="it.chnname"
                        :value="formValue[it.fieldname]" />
              <!-- 不可编辑的开关 -->
              <van-field v-else
                         name="switch"
                         class="not_canedi"
                         :label="it.chnname">
                <template #input>
                  <van-switch v-model="formValue[it.fieldname]"
                              disabled
                              size="20" />
                </template>
              </van-field>
            </div>
          </van-collapse-item>
        </van-collapse>
      </div>
      <!-- 日历组件 -->
      <van-calendar v-model="showCalendar"
                    type="range"
                    :min-date="minDate"
                    :max-date="maxDate"
                    @confirm="onConfirmCalendar" />
    </div>

    <div class="has_feedback"
         v-if="
        (appquery_jump_detail ||
          (use_kq_sign && !this.formValue.is_wxsign) ||
          (showForm && show_err_action_btn && formValue.show_err_action_btn) || (pdSourcePath == 'wxscan' && pdshowbtn)) &&
          !detailParam
      ">
      <!-- 盘点明细确认 -->
      <div class="has_feedback_btn1 onlyOneBtn"
           v-if="pdSourcePath == 'wxscan' && pdshowbtn"
           @click="confirmationOfInventoryDetails">
        {{ $t('module.confirm') }}
      </div>
      <div class="has_feedback_btn1"
           :class="!use_kq_sign || this.formValue.is_wxsign ? 'onlyOneBtn' : ''"
           v-if="appquery_jump_detail"
           @click="viewDetails">
        {{ appquery_jump_btn_title }}
      </div>
      <div class="has_feedback_btn1"
           @click="feedback"
           v-if="use_kq_feedback && !this.formValue.is_wxsign">
        {{ feedback_btn_caption }}
      </div>
      <div class="has_feedback_btn2"
           v-if="use_kq_sign && !this.formValue.is_wxsign"
           @click="SignIn">
        {{ sign_btn_catpion }}
      </div>
      <div class="has_feedback_btn2"
           v-if="show_err_action_btn && formValue.show_err_action_btn"
           @click="checkUrlToGo(formValue)">
        {{ err_action_btn_caption }}
      </div>
    </div>
    <!-- 其他模块如果开启查看明细 -->
    <!-- <div
      v-if="(moduleno != 661 || moduleno != '661') && appquery_jump_detail"
      class="has_feedback"
    >
      <div class="has_feedback_btn1" :class="'onlyOneBtn'" @click="viewDetails">
        {{ appquery_jump_btn_title }}
      </div>
    </div> -->
    <!-- // 协议弹窗 -->
    <van-popup v-model="showAgreePop"
               class="salaryAgreePop"
               round
               :close-on-click-overlay="false">
      <div class="title">
        {{ $t('salarySiginPassword.sspTxt10') }}
      </div>
      <div class="content">
        <iframe id="iframe"
                class="pay_agree_iframe"
                :src="kq_agreement_url"
                style="height:calc(100% - 20px); width: 100%;margin-top: 15px; "
                frameborder="0"></iframe>
      </div>
      <div class="footer">
        <div class="arg1"
             @click="agree">
          {{
            PrivacyTimeOut > 0
              ? `${$t('salarySiginPassword.sspTxt11')}（${PrivacyTimeOut}S）`
              : $t('salarySiginPassword.sspTxt11')
          }}
        </div>
        <div class="arg2"
             @click="notAgree">
          {{ $t('salarySiginPassword.sspTxt12') }}
        </div>
      </div>
    </van-popup>
    <!-- // 反馈内容弹窗 -->
    <van-popup v-model="showFeedback"
               closeable
               class="FeedbackPop"
               round>
      <div class="title">{{ $t('salaryDetails.sdTxt6') }}</div>
      <div class="signExplain">{{ feedback_remark }}</div>
      <div class="reason">
        <van-field v-model="feedback_reason"
                   autosize
                   type="textarea"
                   :placeholder="$t('salaryDetails.sdTxt6')" />
      </div>
      <div class="footer">
        <div @click="submitReason">{{ $t('module.submit') }}</div>
      </div>
    </van-popup>
    <!-- 签名弹窗 -->
    <van-popup v-model="showSign"
               class="hrQuery_signature_PopUp"
               round
               :style="signatureStyle">
      <div style="width: 100%; height: 100%; position: relative;">
        <div :style="horizontalStyle"
             class="wrapper"
             @click.stop>
          <van-overlay :show="showSignLoading">
            <div class="wrapper">
              <van-loading size="24px"
                           vertical
                           color="#2B8DF0">{{
                $t('module.loading')
              }}</van-loading>
            </div>
          </van-overlay>
          <div class="pop_body">
            <div class="nosign_title"
                 v-if="nosign">
              <div class="signTitle">
                <span>{{ sign_btn_catpion }}</span>
                <span style="color: red"
                      @click="closeSpad">{{
                  $t('signaturePad.spTxt2')
                }}</span>
              </div>
              <div class="signExplain">{{ windowsignremark }}</div>
            </div>
            <div class="hb">
              <div class="signaturePad_body"
                   v-if="!nosign">
                <signaturePad ref="hrQuerySignaturePad"
                              :defaultUrl="lastSignPic"
                              :use_last_sign_pic="use_last_sign_pic"
                              :forbit_edit_last_sign="forbit_edit_last_sign"
                              :show="showSign"
                              :signremark="signremark"
                              :mustinput="true"
                              :showConfirmBtn="false"
                              :sign_for_horiz="sign_for_horiz"
                              @getSpad="getSpad"
                              @closeSpad="closeSpad">
                </signaturePad>
              </div>
              <div class="annex_body"
                   v-if="can_sign_upload">
                <div class="title">
                  <span class="title_txt1">上传附件</span>
                </div>
                <van-uploader ref="sign_uploader"
                              accept="image/*"
                              capture="camera"
                              :max-count="9"
                              multiple
                              v-model="signFileList"
                              :before-read="beforeRead">
                </van-uploader>
              </div>
            </div>
          </div>
          <div class="signFooter">
            <div class="button_can"
                 @click="resetSign"
                 v-if="sign_for_horiz">
              {{ $t('signaturePad.spTxt3') }}
            </div>
            <div class="button_can"
                 @click="showSign = false"
                 v-else>
              {{ $t('module.cancel') }}
            </div>
            <div class="button_def"
                 @click="confirmSign">
              {{ $t('module.confirm') }}
            </div>
          </div>
        </div>
      </div>
    </van-popup>

    <!-- 选择人员树弹窗 -->
    <PopTree ref="popTreeNode"
             :whichTree="'employee'"
             :module="moduleno"
             :multiseltree="false"
             :whereFrom="'hrQueryPage'"
             @treeSelectValEvent="treeSelectValEvent"></PopTree>

    <!-- 处理异常列表 -->
    <van-popup v-model="showJumpPicker"
               position="bottom"
               round>
      <van-picker show-toolbar
                  :title="'异常列表'"
                  :columns="jumplist"
                  :value-key="'title'"
                  @confirm="onJumpPickerConfirm"
                  @cancel="showJumpPicker = false">
      </van-picker>
    </van-popup>
    <!-- 扫描二维码弹窗 -->
    <ScanQRCode ref="refScanQRCode"
                @getQRCodeContent="getQRCodeContent"></ScanQRCode>
  </div>
</template>

<script>
// 引入组件库
import { VeTable } from 'vue-easytable' // VePagination, VeIcon, VeLoading, VeLocale
import { GetJsSign } from '@api/hp.js'
import * as imageConversion from 'image-conversion'
import { Dialog, Toast, Notify } from 'vant'
import { saveAs } from 'file-saver'
import signaturePad from '@components/signaturePad'
import PopTree from '@components/PopTree/index.vue'
import ScanQRCode from "@components/scanQRCode/index.vue";
import {
  getHrQueryPageInfo,
  getHrQueryPageInfoRawJson,
  getHrQueryRecord,
  getKqSignParam,
  agreeKqSignProtocol,
  getLastKqSignFeedBackInfo,
  saveKqSignFeedBack,
  signMonthKqSgl,
  ybePostFileStr,
  signMonthKqSglRawJson,
  openKqMonthReport,
  getKqLastSignPicUrl,
  upLoadBase64File,
  getAttachFilePath,
  getReq,
  getDynV8ApiToken,
  scanPdFixedAssets
} from '@api/wx.js'
export default {
  components: {
    signaturePad,
    PopTree,
    VeTable,
    ScanQRCode
  },
  data () {
    const fromH5 = this.$route.query.fromH5
    const userInfo = localStorage.userInfo
      ? JSON.parse(localStorage.userInfo)
      : {}
    const moduleno = this.$route.query.moduleno
    const param = this.$route.query.param || ''
    return {
      v8apitoken: '',
      userInfo,
      fromH5, // 是否从H5过来的
      moduleno, // 当前模块号
      empcode: null, // 当前登录的工号
      langid: 0, // 当前多语言Id
      param, // 从外部过来的参数
      thList: [], // 表头列表
      tableData: [], // 表格数据
      ini: [], // 原始表格数据
      ini2: [], // 原始最后一行合计数据
      totalData: [], // 最后一行合计数据
      searchVal: '', // 搜索关键词
      scrollWidth: 0,
      overflowStyle: 'height:calc(100% - 46px)', // 包含条件和内容区域
      tabStyle: 'height:100%', // 表格高度
      formStyle: 'height:100%', // 表单高度
      pageinfo: {}, // 页面配置信息
      fieldlist: [], // 字段信息
      showForm: false,
      showTable: false,
      groupForm: [], // 有分组的表单信息
      activeNames: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      noGroupForm: [], // 没有分组的表单信息
      collapseStyle: 'height:100%', // 表单分组高度
      formValue: {}, // 表单的字段值
      valueData: [], // 记录
      showYears: false,
      years: [], // 年份数组
      checkedYear: '', // 选中的年份
      showMonths: false,
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], // 月份数组
      checkedMonth: '', // 选中的月份
      showDates: false,
      weeks: [],
      checkdate: '', // 选中的日期（dd）
      checkFullDate: '', // 选中的日期（yyMMdd）
      showCalendar: false, // 日历组件
      minDate: new Date(new Date().getFullYear() - 20, 0, 1),
      maxDate: new Date(new Date().getFullYear() + 20, 0, 31),
      times: 0,
      // ----------661参数start-----
      isagree: false,
      kq_agreement_timeout: 5,
      nosign: false,
      use_kq_agreement: false,
      use_kq_feedback: false,
      use_kq_sign: false,
      kq_agreement_url: '',
      showAgreePop: false, // 协议弹窗
      PrivacyTimeOut: 0, // 倒计时
      PrivacyTimer: null,
      windowsignremark: window.signremark,
      showFeedback: false,
      feedback_reason: '',
      showSign: false,
      use_last_sign_pic: false, // 是否启用上次签名
      forbit_edit_last_sign: false, // 上次签名是否可修改
      feedback_remark: '', // 反馈意见提示信息
      can_sign_upload: false, // 签收时允许上传附件
      lastSignPic: '',
      signFileList: [], // 签收时的附件上传列表
      showSignLoading: false, // 提交loading
      attachFilePath: '', // 附件文件夹
      sign_for_horiz: false, // 启用横向签名模式
      appquery_need_salary_pwd: false, // 进入查询页面时需要工资密码验证
      // ----------661参数end-----
      branchName: '', // 下属姓名
      app_fix_col_count: 0, // 表格固定多少列
      m661Param: '', // 保存当前模块的param
      m661Moduleno: '', // 保存当前模块的模块号
      appquery_jump_btn_title: '', // 查看明细按钮文字
      appquery_jump_detail: false, // 是否显示查看明细
      appquery_jump_fieldname: '', // 查看明细参数名
      appquery_jump_moduleno: '', // 查看明细跳转模块号
      detailParam: '', // 查看明细的查询值
      showCalendar: false,
      CheckMautoid: null,
      signremark: '', // 签收文字描述
      feedback_btn_caption: '', // 反馈意见按钮标题
      sign_btn_catpion: '', // 签收按钮标题
      show_err_action_btn: false, // 是否显示处理异常列
      err_action_btn_caption: '', // 异常按钮标题
      errorRow: {},
      jumplist: [], // 处理异常列表
      showJumpPicker: false,
      merge_cell_count: 0, // 表格自动合并前n列单元格
    }
  },
  computed: {
    showAtfile () {
      let fieldnames = this.thList.map(it => {
        return it.fieldname
      })
      if (fieldnames.includes('atfileflag'))
      {
        return true
      } else
      {
        return false
      }
    },
    // 标题的日期
    titleDate () {
      let str = ''
      if (this.showDates && this.checkFullDate)
      {
        str =
          this.checkFullDate.split('-')[0] +
          '年' +
          this.checkFullDate.split('-')[1] +
          '月'
      }
      return str
    },
    navbarH () {
      // 标题高度
      const navbar = document.getElementsByClassName('common_query_title')[0]
      let hei = navbar ? navbar.clientHeight : '46px'
      return hei
    },
    // 是否采用横向签名样式
    signatureStyle () {
      if (this.sign_for_horiz)
      {
        return ' width: 100%; height:100% '
      } else
      {
        return ' width: 96%;'
      }
    },
    // 是否采用横向签名样式
    horizontalStyle () {
      const winWidth = document.documentElement.scrollWidth
      const winHeight = document.documentElement.scrollHeight
      const top = (winHeight - winWidth) / 2
      const left = 0 - (winHeight - winWidth) / 2
      if (this.sign_for_horiz)
      {
        return `transform: rotate(90deg); width: ${winHeight}px;height: ${winWidth}px; position: absolute; top: ${top}px; left: ${left}px; transform-origin: 50% 50%;`
      } else
      {
        return ' width: 100%; height:100% '
      }
    },
    // 表格合并单元格
    cellSpanOption () {
      if (this.merge_cell_count > 0)
      {
        return {
          bodyCellSpan: this.mergeCells
        }
      } else
      {
        return {}
      }
    },
    // 需要合并的前n-1列的表头
    mergedLeftFieldlist () {
      let fileds = []
      this.fieldlist.forEach((el, i) => {
        if ((i + 1) <= this.merge_cell_count && el.gridwith)
        {
          fileds.push(el.fieldname)
        }
      });
      if (fileds.length > 0)
      {
        return fileds.slice(0, -1)
      } else
      {
        return []
      }
    },
    // 需要合并的最后一列的表头
    mergedRightFieldlist () {
      let fileds = []
      this.fieldlist.forEach((el, i) => {
        if ((i + 1) <= this.merge_cell_count && el.gridwith)
        {
          fileds.push(el.fieldname)
        }
      });
      return fileds
    },
    // 添加合并单元格样式
    cellStyleOption () {
      if (this.merge_cell_count > 0)
      {
        return {
          bodyCellClass: ({ row, column, rowIndex }) => {
            if (this.mergedRightFieldlist.includes(column.field))
            {
              return 'merged-cell';
            }
          }
        }
      } else
      {
        return {}
      }
    },
    // 来自盘点明细？
    pdSourcePath () {
      return this.$route.query.path ? this.$route.query.path : ''
    },
    // 来自盘点明细？
    pdautoid () {
      return this.$route.query.param ? this.$route.query.param : ''
    },
    // 来自盘点明细？
    pdmautoid () {
      return this.$route.query.mautoid ? this.$route.query.mautoid : ''
    },
    // 来自盘点明细？
    pdshowbtn () {
      const showbtn = this.$route.query.showbtn
      if (showbtn == true || showbtn == 'true')
      {
        return true
      } else
      {
        return false
      }
    }
  },
  watch: {
    pageinfo: {
      handler (n) {
        if (n.apptemplateid != 0)
        {
          switch (n.apptemplateid)
          {
            case 1:
              this.showYears = false
              this.showMonths = false
              this.showDates = false
              this.showForm = false
              this.showTable = true
              break
            case 2:
              this.showYears = false
              this.showMonths = false
              this.showDates = false
              this.showForm = true
              this.showTable = false
              break
            case 3:
              this.showYears = false
              this.showMonths = false
              this.showDates = true
              this.showForm = true
              this.showTable = false
              break
            case 4:
              this.showYears = true
              this.showMonths = true
              this.showDates = false
              this.showForm = false
              this.showTable = true
              break
            case 5:
              this.showYears = true
              this.showMonths = true
              this.showDates = false
              this.showForm = true
              this.showTable = false
              break
            case 6:
              this.showYears = true
              this.showMonths = false
              this.showDates = false
              this.showForm = true
              this.showTable = false
              break
            case 7:
              this.showYears = false
              this.showMonths = false
              this.showDates = true
              this.showTable = true
              this.showForm = false
              break
            case 8:
              this.showYears = true
              this.showMonths = false
              this.showDates = false
              this.showForm = false
              this.showTable = true
              break
          }
          //第一次查询后判断一下，定位到当前日期
          if (
            (this.fromH5 == true || this.fromH5 == 'true') &&
            this.times == 1
          )
          {
            // console.log('H5过来的');
            this.moduleno = this.moduleno
            this.empcode = this.userInfo.empcode
            this.langid = localStorage.getItem('langid')
            // 查询页面
            if (this.showYears)
            {
              this.checkedYear = new Date().getFullYear()
            } else
            {
              this.checkedYear = ''
            }
            if (this.showMonths)
            {
              this.checkedMonth = new Date().getMonth() + 1
            } else
            {
              this.checkedMonth = ''
            }
            if (this.showDates)
            {
              this.checkdate = new Date().getDate()
              if (this.checkdate < 10)
              {
                this.checkdate = '0' + this.checkdate
              }
              this.checkFullDate = this.formatDate(new Date(), 'yyyy-MM-dd')
            } else
            {
              this.checkdate = ''
              this.checkFullDate = ''
            }
            this.param = this.param || ''
            this.param = this.checkedYear ? this.checkedYear : this.param
            this.param = this.checkedMonth
              ? this.param + '' + this.add0(this.checkedMonth)
              : this.param
            this.param = this.checkFullDate ? this.param + '' + this.formatDate(new Date(this.checkFullDate), 'yyyyMMdd') : this.param
            // this.param = this.checkedYear + '' + this.add0(this.checkedMonth) + '' + this.formatDate(new Date(this.checkFullDate), 'yyyyMMdd')
            if (n.appquery_opensql) // 第一次当返回的appquery_opensql等于空就传当前日期，不等于空就传空字符
            {
              this.param = ''
            }
            this.getAllPageDatas(this.param)
          }
        }
      },
      deep: true,
      immediate: true
    },
    showTable (n) {
      if (n)
      {
        let i = 1
        let timer = setInterval(() => {
          i++
          if (i == 3)
          {
            clearInterval(timer)
          }
          const has_feedback = document.getElementsByClassName(
            'has_feedback'
          )[0]
          if (has_feedback)
          {
            const feedH = has_feedback.clientHeight
            this.overflowStyle =
              'height: calc(100% - ' + (feedH + this.navbarH) + 'px)'
          } else
          {
            this.overflowStyle = 'height:calc(100% - ' + this.navbarH + 'px)'
          }
          const dateContent = document
            .getElementsByClassName('overflow_div')[0]
            .querySelector('.date_content')
          if (dateContent)
          {
            let dateH = dateContent.clientHeight
            if (this.showTable)
            {
              const searchContent = document
                .getElementsByClassName('overflow_div')[0]
                .querySelector('.van-search')
              dateH += searchContent.clientHeight
              // alert(1)
            }
            this.tabStyle = 'height: calc(100% - ' + dateH + 'px)'
          }
        }, 1000)
      }
    },
    showForm (n) {
      if (n)
      {
        let i = 1
        let timer = setInterval(() => {
          i++
          if (i == 3)
          {
            clearInterval(timer)
          }
          const dateContent = document
            .getElementsByClassName('overflow_div')[0]
            .querySelector('.date_content')
          if (dateContent)
          {
            const dateH = dateContent.clientHeight
            this.formStyle = 'height: calc(100% - ' + dateH + 'px)'
          }
          const noGroupF = document
            .getElementsByClassName('overflow_div')[0]
            .querySelector('.form_content')
            .querySelector('.noGroup_form')
          if (noGroupF)
          {
            const dateF = noGroupF.clientHeight
            this.collapseStyle = 'height: calc(100% - ' + dateF + 'px)'
          }
          const has_feedback = document.getElementsByClassName(
            'has_feedback'
          )[0]
          if (has_feedback)
          {
            const feedH = has_feedback.clientHeight
            this.overflowStyle =
              'height: calc(100% - ' + (feedH + this.navbarH) + 'px)'
          }
        }, 1000)
      }
    },
    formValue (n) {
      if (this.moduleno == 661 || this.moduleno == '661')
      {
        setTimeout(() => {
          const has_feedback = document.getElementsByClassName(
            'has_feedback'
          )[0]
          // if (has_feedback && !n.is_wxsign)
          if (has_feedback)
          {
            const feedH = has_feedback.clientHeight
            this.overflowStyle =
              'height: calc(100% - ' + (feedH + this.navbarH) + 'px)'
          } else
          {
            this.overflowStyle = 'height:calc(100% - ' + this.navbarH + 'px)'
          }
        }, 500)
      }
    },
    showSign (n) {
      if (!n)
      {
        this.signFileList = []
      }
    }
  },
  created () {
    // 根据当前日期获取本周日期
    this.getMonDayAndSunDay(new Date())
    // 获取年
    this.getYearsByDate(new Date())
    // 获取记录附件文件夹接口
    this.getAttachFilePathData()
  },
  mounted () {
    this.fromH5 = this.$route.query.fromH5
    this.moduleno = this.$route.query.moduleno
    this.param = this.$route.query.param

    /**
     * 特定模板0
     * 模板1（无需查询，用表格显示多笔记录）
     * 模板2（无需查询，用表单显示1笔记录）
     * 模板3（按日期查询1笔记录，用表单显示）
     * 模板4（按月份查询多笔记录，用表格显示）
     * 模板5（按月份查询1笔记录，用表单显示）
     * 模板6（按年份查询多笔记录，用表格显示）
     * 模板7（按日期查询多笔记录，用表格显示）
     * 模板8（按年份查询1笔记录，用表单显示）
     */
    // 如果initParams存在的话就是从H5过来的，如果不存在则是外部过来的
    if (this.fromH5 == true || this.fromH5 == 'true')
    {
      // console.log('H5过来的');
      this.moduleno = this.moduleno
      this.empcode = this.userInfo.empcode
      this.langid = localStorage.getItem('langid')
      this.param = this.$route.query.param
      if (this.param)
      {
        this.times += 1
        this.getAllPageDatas(this.param)
        this.checkedYear = this.param.substring(0, 4)
        this.checkedMonth = this.param.substring(4, 6)
      } else
      {
        // this.getAllPageDatas('')
        this.times += 1
        this.getHrQueryPageInfoData(
          {
            moduleno: this.moduleno,
            empcode: this.empcode,
            langid: this.langid
          },
          JSON.stringify({})
        )
      }
    } else
    {
      // console.log('外部过来的');
      this.moduleno = this.$route.query.moduleno
      this.empcode = this.$route.query.empcode || this.userInfo.empcode
      this.langid = this.$route.query.langid
      this.param = this.$route.query.param
      if (this.empcode)
      {
        // 查询页面
        this.getAllPageDatas(this.param)
        if (this.param)
        {
          this.checkedYear = this.param.substring(0, 4)
          this.checkedMonth = this.param.substring(4, 6)
        }
      } else
      {
        this.$router.push('/login')
      }
    }
    // 20231204 全部模块都要查询
    this.getKqSignParamData()

    // if (window.globalurls != window.location.href)
    // {
    //   location.href = window.location.href
    // }
  },
  methods: {
    // 获取鉴权地址
    getmm () {
      let mm = window.location.href
      var u = navigator.userAgent
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
      if (isiOS)
      {
        mm = window.globalurls
      }
      if (mm.indexOf('#') > -1) mm = mm.split('#')[0]
      return mm
    },
    // 盘点明细确认
    confirmationOfInventoryDetails () {
      scanPdFixedAssets({
        mautoid: this.pdmautoid,
        autoid: this.pdautoid,
        username: this.userInfo.username
      }).then(res => {
        if (res.data[0] && res.data[0].info)
        {
          Toast.fail(res.data[0].info)
          return
        } else
        {
          this.wxScanQRCode()
        }
      })
    },
    // 扫描二维码弹窗回调
    getQRCodeContent (result) {
      // console.log('getQRCodeContent', result);
      const oldUrl = 'http://hyclound.cn/weixin/queryrpt/zhongzhuan.html?hyrptparas=固定资产资料' // 旧版
      const newUrl = 'commHrQueryPage?moduleno=1320&fromH5=true&path=wxscan'
      if (result.indexOf(oldUrl) > -1 || result.indexOf(newUrl) > -1)
      {
        const url = new URL(result);
        // 使用searchParams属性来访问查询参数
        const params = url.searchParams;
        // 获取特定的参数
        let autoid = ''
        let moduleno = ''
        if (result.indexOf(oldUrl) > -1)
        {
          const hyrptparas = params.get('hyrptparas');
          moduleno = hyrptparas.split('|')[3]
          autoid = params.get('autoid');
        } else
        {
          moduleno = params.get('moduleno');
          autoid = params.get('param');
        }
        if (autoid)
        {
          const host = window.location.origin;
          const url = host + "/commHrQueryPage?moduleno=" + moduleno + '&param=' + autoid + '&fromH5=true&path=wxscan&showbtn=true&fromPage=fixedAssetInventoryDetail&mautoid=' + this.mautoid + '&activeName=' + this.$route.query.activeName
          // location.href = url + '&showbtn=true' + '&mautoid=' +**;
          location.replace(url)
        }
      } else
      {
        alert('cancel:' + '二维码地址不合法')
      }
    },
    // 盘点确认后继续扫码
    wxScanQRCode () {
      this.$refs.refScanQRCode.showScanCode = true
    },
    // 表格body合并单元格
    mergeCells ({ row, column, rowIndex }) {
      // 只处理前n-1列的合并
      if (this.mergedLeftFieldlist.includes(column.field))
      {
        const prevRow = this.tableData[rowIndex - 1]
        let nextRow = this.tableData[rowIndex + 1]
        let currentKey = this.getMergeKey(this.mergedLeftFieldlist, row)
        // 判断是否为新组合的起始行
        if (!prevRow || this.getMergeKey(this.mergedLeftFieldlist, prevRow) !== currentKey)
        {
          let rowspan = 1
          // 计算相同组合的行数
          while (nextRow && this.getMergeKey(this.mergedLeftFieldlist, nextRow) === currentKey)
          {
            rowspan++
            nextRow = this.tableData[rowIndex + rowspan]
          }
          return { rowspan, colspan: 1 }
        }
        return { rowspan: 0, colspan: 0 }
      } else if ([this.mergedRightFieldlist[this.mergedRightFieldlist.length - 1]].includes(column.field))
      {
        // 处理最后一列的合并
        const currentKey = this.getMergeKey(this.mergedRightFieldlist, row)
        const prevRow = this.tableData[rowIndex - 1]
        let nextRow = this.tableData[rowIndex + 1]
        // 判断是否为新组合的起始行
        if (!prevRow || this.getMergeKey(this.mergedRightFieldlist, prevRow) !== currentKey)
        {
          let rowspan = 1
          // 计算相同组合的行数
          while (nextRow && this.getMergeKey(this.mergedRightFieldlist, nextRow) === currentKey)
          {
            rowspan++
            nextRow = this.tableData[rowIndex + rowspan]
          }
          return { rowspan, colspan: 1 }
        }
        return { rowspan: 0, colspan: 0 }
      }
    },
    // 根据字段名数组获取合并单元格组合值
    getMergeKey (fieldList, row) {
      let Key = ''
      fieldList.forEach((fl, i) => {
        if (row)
        {
          Key += row[fl]
        }
        if (i < fieldList.length - 1)
        { // 除了最后一个元素外，都加上'-' 
          if (Key)
          {
            Key += '-'
          }
        }
      });
      return Key
    },
    // 关闭下属人员标签
    closeBranch () {
      // 如果initParams存在的话就是从H5过来的，如果不存在则是外部过来的
      if (this.fromH5 == true || this.fromH5 == 'true')
      {
        // console.log('H5过来的');
        this.empcode = this.userInfo.empcode
      } else
      {
        // console.log('外部过来的');
        this.empcode = this.$route.query.empcode
      }
      this.branchName = ''
      // 查询页面
      this.getAllPageDatas(this.param)
    },
    // 选择下属人员弹窗回调
    treeSelectValEvent (data) {
      this.empcode = data.empcode
      this.branchName = data.empcode + '-' + data.empname
      // 查询页面
      this.getAllPageDatas(this.param)
    },
    // 查看下属数据
    showBranch () {
      this.$refs.popTreeNode.module = this.moduleno
      this.$refs.popTreeNode.treename = 'emptree'
      this.$refs.popTreeNode.editstate = 2
      this.$refs.popTreeNode.showEmpTreePop('下属')
    },
    // 上传前处理
    beforeRead (file) {
      let _this = this
      // console.log(this.fileLists, "压缩前", file)
      if (Array.isArray(file))
      {
        // 一定要异步和for of 否则批量压缩会出错
        return new Promise(async (resolve, reject) => {
          let arr = []
          let arr2 = []
          Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: '处理中...'
          })
          for (let item of file)
          {
            if (item.type.indexOf('image') != -1)
            {
              await imageConversion.compressAccurately(item, 500).then(res => {
                res = new File([res], item.name, {
                  type: res.type,
                  lastModified: Date.now()
                })
                // console.log("多图片上传，压缩后", res)
                arr.push(res)
              })
            } else
            {
              arr2.push(item)
            }
          }
          let arr3 = [...arr, ...arr2]
          Toast.clear()
          resolve(arr3)
        })
      } else
      {
        if (file.type.indexOf('image') != -1)
        {
          Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: '处理中...'
          })
          return new Promise((resolve, reject) => {
            imageConversion.compressAccurately(file, 500).then(res => {
              res = new File([res], file.name, {
                type: res.type,
                lastModified: Date.now()
              })
              // console.log(_this.fileLists, "单图片上传，压缩后", res)
              Toast.clear()
              resolve(res)
            })
          })
        } else
        {
          return new Promise((resolve, reject) => {
            resolve(file)
          })
        }
      }
    },
    // 获取记录附件文件夹接口
    getAttachFilePathData () {
      getAttachFilePath().then(res => {
        this.attachFilePath = res
      })
    },
    // 签收弹窗确定按钮
    confirmSign () {
      if (this.nosign)
      {
        // 不需要签名的时候直接签收
        Dialog.confirm({
          title: this.$t('signaturePad.spTxt5'),
          message: this.$t('signaturePad.spTxt6'),
          confirmButtonColor: '#2B8DF0'
        })
          .then(() => {
            this.getSpad(null)
          })
          .catch(() => { })
      } else
      {
        // 需要签名的时候走签名
        this.$refs.hrQuerySignaturePad.save()
      }
    },
    // 签名弹窗关闭
    closeSpad () {
      this.showSign = false
    },
    // 661的查看考勤明细按钮
    viewDetails () {
      // this.moduleno = 660
      this.m661Param = this.param
      this.m661Moduleno = this.moduleno
      //
      this.moduleno = this.appquery_jump_moduleno
      this.empcode = this.userInfo.empcode
      this.langid = localStorage.getItem('langid')
      this.detailParam = this.formValue[this.appquery_jump_fieldname]
      console.log(this.detailParam, 'this.detailParam')
      if (this.detailParam)
      {
        this.checkedYear = this.detailParam.substring(0, 4)
        this.checkedMonth = this.detailParam.substring(4, 6)
      }
      // 查询页面
      this.getAllPageDatas(this.detailParam)
    },
    // 保存反馈意见
    submitReason () {
      saveKqSignFeedBack({
        moduleno: this.moduleno,
        autoid: this.formValue.autoid,
        empcode: this.empcode,
        feedback_reason: this.feedback_reason
      }).then(res => {
        if (res.data[0].info)
        {
          Notify({ type: 'danger', message: res.data[0].info })
        } else
        {
          this.showFeedback = false
          Notify({ type: 'success', message: this.$t('module.submitScu') })
        }
      })
    },
    // 反馈意见
    feedback () {
      if (this.formValue.is_wxsign)
      {
        Toast.fail('当前记录已签收！')
        return
      }
      if (this.formValue.autoid)
      {
        this.showFeedback = true
        getLastKqSignFeedBackInfo({
          moduleno: this.moduleno,
          empid: this.userInfo.empid,
          yymm: this.param
        }).then(res => {
          this.feedback_reason = res.data[0].info
        })
      } else
      {
        Toast.fail('当前未查询到记录！')
      }
    },
    // 签收按钮
    SignIn () {
      if (this.formValue.is_wxsign)
      {
        Toast.fail('当前记录已签收！')
        return
      }
      if (this.formValue.autoid)
      {
        if (this.nosign == true || this.nosign == 'true')
        {
          // 证明不需要签名
          // Dialog.confirm({
          //   title: this.$t('salaryDetails.sdTxt2'),
          //   message: this.windowsignremark,
          //   confirmButtonColor: '#2B8DF0'
          // }).then(() => {
          // on confirm
          // this.getSpad(null)
          this.showSign = true
          // }).catch(() => {
          // on cancel
          // })
        } else
        {
          // 要签名
          this.showSign = true
        }
      } else
      {
        Toast.fail('当前未查询到记录！')
      }
    },
    // 签名弹窗提交回调
    getSpad (url) {
      // console.log(this.signFileList, 'signFileListsignFileList');
      this.showSignLoading = true
      // if (
      //   this.userInfo.username == '7002' ||
      //   this.userInfo.username == '000012'
      // ) {
      //   ybePostFileStr({
      //     autoid: this.formValue.autoid,
      //     username: this.userInfo.username,
      //     filebase64str: url
      //   }).then(res => {
      //     console.log(res)
      //     if (res.iserror == 0) {
      //       Toast('测试成功')
      //       this.showSign = false
      //       this.getAllPageDatas(this.param)
      //     }
      //   })
      // } else {
      //signMonthKqSgl
      signMonthKqSglRawJson({
        moduleno: this.moduleno,
        autoid: this.formValue.autoid,
        username: this.userInfo.username,
        filebase64str: url
      }).then(async res => {
        if (res.iserror == 0)
        {
          if (this.signFileList.length > 0)
          {
            let cunts = 0
            for (let file of this.signFileList)
            {
              const base64s = file.content
              let f = file.file.name
              const ext = f.substring(f.lastIndexOf('.') + 1)
              let params = {
                filebase64str: base64s,
                upflag: 2,
                moduleno: this.moduleno,
                autoid: this.formValue.autoid,
                uploadpath: this.attachFilePath,
                fileext: ext,
                username: this.userInfo.username,
                packagetype: ''
              }
              await upLoadBase64File(params).then(rest => {
                cunts = cunts + 1
              })
            }
            if (cunts == this.signFileList.length)
            {
              this.showSignLoading = false
              Toast(this.$t('salaryDetails.sdTxt4'))
              this.showSign = false
              this.getAllPageDatas(this.param)
            }
          } else
          {
            this.showSignLoading = false
            Toast(this.$t('salaryDetails.sdTxt4'))
            this.showSign = false
            this.getAllPageDatas(this.param)
          }
        } else
        {
          this.showSignLoading = false
          Dialog({
            type: 'danger',
            message: res.errormsg
              ? res.errormsg.replace('<br>', '\n')
              : '数据处理异常，请及时联系管理员！'
          })
        }
      })
      // }
    },
    // 同意
    agree () {
      if (this.PrivacyTimeOut > 0)
      {
        return
      } else
      {
        agreeKqSignProtocol({
          moduleno: this.moduleno,
          empcode: this.empcode
        }).then(res => {
          if (res.data[0].info)
          {
            Notify({ type: 'danger', message: res.data[0].info })
          } else
          {
            this.showAgreePop = false
          }
        })
      }
    },
    // 不同意
    notAgree () {
      this.onClickLeft()
    },
    //考勤签收-隐私弹窗同意倒计时
    getTimeCount () {
      const TIME_COUNT = this.kq_agreement_timeout
      if (!this.PrivacyTimer)
      {
        this.PrivacyTimeOut = TIME_COUNT
        this.PrivacyTimer = setInterval(() => {
          if (this.PrivacyTimeOut > 0 && this.PrivacyTimeOut <= TIME_COUNT)
          {
            this.PrivacyTimeOut--
          } else
          {
            clearInterval(this.PrivacyTimer)
            this.PrivacyTimer = null
          }
        }, 1000)
      }
    },
    // 获取考勤签收相关参数
    getKqSignParamData () {
      getKqSignParam({ moduleno: this.moduleno, empcode: this.empcode }).then(
        res => {
          this.signremark = res.data[0].signremark
          this.windowsignremark = this.signremark
            ? this.signremark
            : window.signremark
          this.isagree = res.data[0].isagree
          this.kq_agreement_timeout = res.data[0].kq_agreement_timeout
          this.nosign = res.data[0].nosign
          this.use_kq_agreement = res.data[0].use_kq_agreement
          this.use_kq_feedback = res.data[0].use_kq_feedback
          this.use_kq_sign = res.data[0].use_kq_sign
          this.kq_agreement_url = res.data[0].kq_agreement_url
          this.use_last_sign_pic = res.data[0].use_last_sign_pic
          this.forbit_edit_last_sign = res.data[0].forbit_edit_last_sign
          this.feedback_remark = res.data[0].feedback_remark
          if (this.use_kq_agreement == true && this.isagree == false)
          {
            this.showAgreePop = true
            this.getTimeCount()
          }
          this.feedback_btn_caption = res.data[0].feedback_btn_caption // 反馈意见按钮标题
          this.sign_btn_catpion = res.data[0].sign_btn_catpion // 签收按钮标题
          this.can_sign_upload = res.data[0].can_sign_upload // 签收时允许上传附件
          this.sign_for_horiz = res.data[0].sign_for_horiz
          this.appquery_need_salary_pwd = res.data[0].appquery_need_salary_pwd

          if (
            this.appquery_need_salary_pwd &&
            !(
              sessionStorage.getItem(
                'appquery_need_salary_pwd' + this.moduleno
              ) == '1'
            )
          )
          {
            // 进入查询页面时需要工资密码验证 且当前没有签名过
            this.$router.push({
              path: '/salarySiginPassword',
              query: {
                fromH5: false,
                goto: 'commHrQueryPage',
                search: window.location.search,
                moduleno: this.moduleno
              }
            })
          } else
          {
            sessionStorage.setItem(
              'appquery_need_salary_pwd' + this.moduleno,
              '0'
            )
          }
        }
      )
    },
    // 获取上一次考勤签收图片地址
    getKqLastSignPicUrlData () {
      getKqLastSignPicUrl({
        moduleno: this.moduleno,
        autoid: this.formValue.autoid,
        username: this.userInfo.username
      }).then(res => {
        if (typeof res == 'string')
        {
          this.lastSignPic = res
        } else
        {
          this.lastSignPic = ''
        }
      })
    },
    // 回退
    onClickLeft () {
      // this.$router.back()
      const fromPage = this.$route.query.fromPage
      if (fromPage == 'home')
      {
        this.$router.push('/home').catch(err => {
          console.log(err)
        })
      } else if (fromPage == 'phonesign')
      {
        this.$router
          .push({
            path: '/phonesign',
            query: {
              ssid: this.$route.query.ssid,
              bssid: this.$route.query.bssid,
              lng: this.$route.query.lng,
              lat: this.$route.query.lat
            }
          })
          .catch(err => {
            console.log(err)
          })
      } else if (fromPage == 'personCen')
      {
        this.$router.push('/personCen').catch(err => {
          console.log(err)
        })
      } else if (fromPage == 'fixedAssetInventoryDetail')
      {
        // 来自盘点明细
        this.$router.push({
          path: '/fixedAssetInventoryDetail',
          query: { autoid: this.pdmautoid, activeName: this.$route.query.activeName }
        })
      } else
      {
        // 当跳转参数不为空就返回上一个
        if (this.detailParam)
        {
          this.moduleno = this.m661Moduleno
          this.param = this.m661Param
          console.log(this.param, 'this.param')
          if (this.param)
          {
            this.checkedYear = this.param.substring(0, 4)
            this.checkedMonth = this.param.substring(4, 6)
          }
          // 查完之后将查看明细的查询值置空
          this.detailParam = ''
          // 查询页面
          this.getAllPageDatas(this.param)
        } else
        {
          this.$router.push('/query').catch(err => {
            console.log(err)
          })
        }
      }
    },
    // 日历关闭回调
    onConfirmCalendar (date) {
      const [start, end] = date
      this.showCalendar = false
      this.param =
        this.formatDate(start, 'yyyyMMdd') +
        '-' +
        this.formatDate(end, 'yyyyMMdd')
      // 查询页面
      this.getAllPageDatas(this.param)
    },
    // 根据某一天获取所在周的日期
    getMonDayAndSunDay (date) {
      let blank = [
        { week: '周一', date: '', fulldate: null },
        { week: '周二', date: '', fulldate: null },
        { week: '周三', date: '', fulldate: null },
        { week: '周四', date: '', fulldate: null },
        { week: '周五', date: '', fulldate: null },
        { week: '周六', date: '', fulldate: null },
        { week: '周日', date: '', fulldate: null }
      ]
      blank.forEach((el, idx) => {
        let fulldate = null
        if (new Date(date).getDay() > 0)
        {
          // 大于0表示不是星期日
          fulldate = new Date(
            new Date(date).getTime() -
            3600 * 1000 * 24 * (new Date(date).getDay() - (idx + 1))
          )
        } else
        {
          // 这是星期日
          fulldate = new Date(
            new Date(date).getTime() -
            3600 * 1000 * 24 * (new Date(date).getDay() - (idx - 6))
          )
        }
        el.fulldate = this.formatDate(fulldate, 'yyyy-MM-dd')
        let da = fulldate.getDate()
        if (da < 10)
        {
          da = '0' + da
        }
        el.date = da
      })
      this.weeks = blank
      // console.log(this.weeks, 'weeksweeks');
    },
    // 不够就补零
    add0 (m) {
      if (m > 0)
      {
        return m < 10 ? '0' + m : m
      } else
      {
        return ''
      }
    },
    // 日期时间转换格式
    formatDate (date, rule) {
      if (date)
      {
        const time = new Date(date)
        const y = time.getFullYear()
        const m = time.getMonth() + 1
        const d = time.getDate()
        const h = time.getHours()
        const mm = time.getMinutes()
        const s = time.getSeconds()
        if (rule == 'yyyy-MM-dd')
        {
          return y + '-' + this.add0(m) + '-' + this.add0(d)
        } else if (rule == 'yyyyMMdd')
        {
          return y + '' + this.add0(m) + '' + this.add0(d)
        } else
        {
          return (
            y +
            '-' +
            this.add0(m) +
            '-' +
            this.add0(d) +
            ' ' +
            this.add0(h) +
            ':' +
            this.add0(mm)
          )
          // + ':' + this.add0(s)
        }
      } else
      {
        return ''
      }
    },
    // 选择某一天
    getOneDay (it) {
      if (
        this.checkdate == it.date &&
        this.checkFullDate == it.fulldate &&
        false
      )
      {
        this.checkdate = ''
        this.checkFullDate = ''
      } else
      {
        this.checkdate = it.date
        this.checkFullDate = it.fulldate
      }
      this.param = this.formatDate(this.checkFullDate, 'yyyyMMdd')
      // 查询页面
      this.getAllPageDatas(this.param)
    },
    // 左右切换周
    arrowDates (val) {
      if (val == 'left')
      {
        // 根据当前weeks里的第一天获取上周日期
        let preDate = new Date(
          new Date(this.weeks[0].fulldate).getTime() - 24 * 60 * 60 * 1000
        ) //前一天
        this.getMonDayAndSunDay(this.formatDate(preDate, 'yyyy-MM-dd'))
      } else if (val == 'right')
      {
        // 根据当前weeks里的最后一天获取下周日期
        let nextDate = new Date(
          new Date(this.weeks[6].fulldate).getTime() + 24 * 60 * 60 * 1000
        ) //后一天
        this.getMonDayAndSunDay(this.formatDate(nextDate, 'yyyy-MM-dd'))
      }
      // 查询某一天数据
      let isToday = false
      let todayIdx = 0
      for (let i = 0; i < this.weeks.length; i++)
      {
        const it = this.weeks[i]
        if (it.fulldate == this.formatDate(new Date(), 'yyyy-MM-dd'))
        {
          isToday = true
          todayIdx = i
        }
      }
      // 如果是当前日期就选当前日期，否则选择一周的星期一
      if (isToday)
      {
        this.getOneDay(this.weeks[todayIdx])
      } else
      {
        this.getOneDay(this.weeks[0])
      }
    },
    // 获取页面所有信息
    getAllPageDatas (param) {
      // 查询记录
      getHrQueryRecord({
        moduleno: this.moduleno,
        empcode: this.empcode,
        param: param,
        langid: this.langid
      }).then(res => {
        this.times += 1
        this.valueData = res.data
        this.formValue = res.data.length > 0 ? res.data[0] : {}
        // 调用已查阅接口--2024-09-13改动（没启用签收，也要触发）// this.use_kq_sign &&
        if (!this.detailParam && res.data.length > 0)
        {
          openKqMonthReport({
            moduleno: this.moduleno,
            autoid: res.data[0].autoid,
            empid: this.userInfo.empid
          }).then(res => {
            if (res.data[0].info)
            {
              Toast.fail(res.data[0].info)
            }
          })
          this.getKqLastSignPicUrlData()
        }
        // 查询页面
        this.getHrQueryPageInfoData(
          {
            moduleno: this.moduleno,
            empcode: this.empcode,
            langid: this.langid
          },
          JSON.stringify(res)
        )
      })
    },
    // 获取查询页面相关配置信息
    getHrQueryPageInfoData (data, jsonstr) {
      getHrQueryPageInfoRawJson({
        moduleno: data.moduleno,
        empcode: data.empcode,
        langid: data.langid,
        jsonstr
      }).then(res => {
        this.fieldlist = res.fieldlist
        this.jumplist = res.jumplist
        this.pageinfo = res.pageinfo[0]
        this.app_fix_col_count = this.pageinfo.app_fix_col_count
        this.appquery_jump_btn_title = this.pageinfo.appquery_jump_btn_title
        this.appquery_jump_detail = this.pageinfo.appquery_jump_detail
        this.appquery_jump_fieldname = this.pageinfo.appquery_jump_fieldname
        this.appquery_jump_moduleno = this.pageinfo.appquery_jump_moduleno
        this.show_err_action_btn = this.pageinfo.show_err_action_btn // 是否显示处理异常列
        this.err_action_btn_caption = this.pageinfo.err_action_btn_caption // 按钮标题
        this.merge_cell_count = this.pageinfo.merge_cell_count
        const form = [2, 3, 5, 6]
        if (this.pageinfo.apptemplateid != 0)
        {
          if (form.includes(this.pageinfo.apptemplateid))
          {
            // 用表单显示
            this.showForm = true
            let afterData = []
            let tempArr = []
            // 遍历分组
            for (let i = 0; i < this.fieldlist.length; i++)
            {
              // 解析没有分组的表单信息
              if (!this.fieldlist[i].appgroupname)
              {
                this.noGroupForm = this.fieldlist.filter(it => {
                  return !it.appgroupname
                })
              } else
              {
                if (tempArr.indexOf(this.fieldlist[i].appgroupname) === -1)
                {
                  let arr = []
                  if (this.fieldlist[i].gridwith)
                  {
                    arr.push(JSON.parse(JSON.stringify(this.fieldlist[i])))
                  }
                  afterData.push({
                    name: this.fieldlist[i].appgroupname,
                    origin: arr
                  })
                  tempArr.push(this.fieldlist[i].appgroupname)
                } else
                {
                  for (let j = 0; j < afterData.length; j++)
                  {
                    if (afterData[j].name == this.fieldlist[i].appgroupname)
                    {
                      if (this.fieldlist[i].gridwith)
                      {
                        afterData[j].origin.push(
                          JSON.parse(JSON.stringify(this.fieldlist[i]))
                        )
                      }
                      break
                    }
                  }
                }
              }
            }
            this.groupForm = afterData
          } else
          {
            // 用表格显示
            this.thList = JSON.parse(JSON.stringify(this.fieldlist))
            this.thList = this.thList.filter(it => {
              return it.gridwith
            })
            // 是否显示处理异常列
            if (this.show_err_action_btn)
            {
              this.thList.unshift({
                type: 'btn',
                fieldname: '',
                chnname: '操作',
                gridwith: 40,
                footerkind: 'skNone',
                appgroupname: ''
              })
            }
            let obj = {
              fieldname: 'serial',
              chnname: '序号',
              gridwith: this.pageinfo.sqnum_width || 25,
              footerkind: 'skNone',
              appgroupname: ''
            }
            if (this.pageinfo.sqnum_width != 0)
            {
              this.thList.unshift(obj)
            }
            // 固定多少列
            let frozenColCount = this.app_fix_col_count ? parseInt(this.app_fix_col_count + 1) : 1 // 因为手工添加了一列“序号”所以要加1
            // 如果有操作列，再加1
            if (this.show_err_action_btn)
            {
              frozenColCount = frozenColCount + 1
            }
            this.scrollWidth = 0
            this.thList.forEach((it, ii) => {
              if (ii < frozenColCount)
              {
                it.fixed = 'left'
                this.scrollWidth += it.gridwith * 2
              }
              it.title = it.chnname ? it.chnname.replace(/<br>/g, "\n") : it.chnname
              it.field = it.fieldname

              it.key = 'k' + ii
              it.width = it.gridwith * 2 //先注释掉用自适应显示
              const fieldvalue_align = it.fieldvalue_align || 'center'
              it.align = fieldvalue_align
              // 自定义单元格
              if (it.fieldname == 'atfileflag')
              {
                // 附件
                it.renderBodyCell = ({ row, column, rowIndex }, h) => {
                  const url = require('@assets/img/ft_ico_fj.png')
                  const bgcolor = row.v8_rgb_color_field
                    ? row.v8_rgb_color_field
                    : '#ffffff'
                  const fontColor = row.v8_rgb_font_color
                    ? row.v8_rgb_font_color
                    : '#000000d9'
                  const style =
                    'height: 100%; display: flex; align-items: center;width: 100%;padding:10px; background:' +
                    bgcolor +
                    ';color:' +
                    fontColor +
                    ';'
                  if (this.showAtfile && row.atfileflag == 1)
                  {
                    return (
                      <div
                        style={style}
                        on-click={() => {
                          // console.log(row, 'rowrow');
                          if (row.module_file_url)
                          {
                            window.open(row.module_file_url)
                          }
                        }}
                      >
                        <img src={url} alt="" style="width:19px;height:18px;" />
                      </div>
                    )
                  } else
                  {
                    return <div style={style}></div>
                  }
                }
              } else if (it.fielddatatype == 'bit')
              {
                // 布尔类型
                it.renderBodyCell = ({ row, column, rowIndex }, h) => {
                  const text = row[column.field]
                  const bgcolor = row.v8_rgb_color_field
                    ? row.v8_rgb_color_field
                    : '#ffffff'
                  const fontColor = row.v8_rgb_font_color
                    ? row.v8_rgb_font_color
                    : '#000000d9'
                  const style =
                    'height: 100%; display: flex; align-items: center; justify-content: center;width: 100%;padding:10px; background:' +
                    bgcolor +
                    ';color:' +
                    fontColor +
                    ';'
                  const url = text
                    ? require('@assets/img/comm_qy_checked.png')
                    : require('@assets/img/comm_qy_uncheck.png')

                  if (
                    window.CloundEntid == '236' &&
                    data.moduleno == '1228' &&
                    it.fieldname == 'release' &&
                    !text
                  )
                  {
                    /// 联升 访客记录特殊修改
                    return (
                      <div style={style}>
                        <van-button
                          type="info"
                          size="small"
                          on-click={() => this.b4lianShengFX(row)}
                        >
                          确认放行
                        </van-button>
                      </div>
                    )
                  } else
                  {
                    return (
                      <div style={style}>
                        <img src={url} alt="" style="width:20px;height:20px;" />
                      </div>
                    )
                  }
                }
              } else
              {
                // 文本
                it.renderBodyCell = ({ row, column, rowIndex }, h) => {
                  const text = row[column.field]
                  const bgcolor = row.v8_rgb_color_field
                    ? row.v8_rgb_color_field
                    : '#ffffff'
                  const fontColor = row.v8_rgb_font_color
                    ? row.v8_rgb_font_color
                    : '#000000d9'
                  const style =
                    'height: 100%;  align-items: center;width: 100%;padding:10px; font-size:' +
                    this.pageinfo.fontsize +
                    'px;text-align:' +
                    fieldvalue_align +
                    '; background:' +
                    bgcolor +
                    ';color:' +
                    fontColor +
                    ';'
                  return <div style={style}>{text}</div>
                }
              }
              // 是否显示处理异常列
              if (it.type == 'btn')
              {
                it.renderBodyCell = ({ row, column, rowIndex }, h) => {
                  const show_err_action_btn = row.show_err_action_btn
                  const bgcolor = row.v8_rgb_color_field
                    ? row.v8_rgb_color_field
                    : '#ffffff'
                  const fontColor = row.v8_rgb_font_color
                    ? row.v8_rgb_font_color
                    : '#000000d9'
                  const style =
                    'height: 100%;  align-items: center;width: 100%;padding:10px; font-size: 14px;text-align:' +
                    fieldvalue_align +
                    '; background:' +
                    bgcolor +
                    ';color:' +
                    fontColor +
                    ';' +
                    ' display: flex; align-items: center; justify-content: center;'
                  if (show_err_action_btn)
                  {
                    return (
                      <div style={style}>
                        <van-button
                          type="info"
                          size="small"
                          on-click={() => this.checkUrlToGo(row)}
                        >
                          {this.err_action_btn_caption}
                        </van-button>
                      </div>
                    )
                  } else
                  {
                    return <div style={style}> </div>
                  }
                }
              }
            })
            // console.log(this.scrollWidth, 'scrollWidthscrollWidthscrollWidth');
            // console.log(this.thList, 'this.thList');
            this.tableData = JSON.parse(JSON.stringify(this.valueData))
            // 改造数据结构
            this.tableData.forEach((it, idx) => {
              it.serial = idx + 1
            })

            // 如果表格启用汇总
            if (this.pageinfo.openfooter)
            {
              this.totalData = [{ serial: '汇总' }]
              this.thList.forEach(it => {
                if (it.fieldname != 'serial')
                {
                  if (it.gridwith && it.footerkind != 'skNone')
                  {
                    let result = ''
                    const values = this.tableData.map(item =>
                      parseFloat(item[it.fieldname])
                    )
                    if (!values.every(value => isNaN(value)))
                    {
                      switch (it.footerkind)
                      {
                        case 'skAverage':
                          result = this.computedAverage(values)
                          break
                        case 'skCount':
                          result = this.computedCount(values)
                          break
                        case 'skMax':
                          result = this.computedMax(values)
                          break
                        case 'skMin':
                          result = this.computedMin(values)
                          break
                        case 'skSum':
                          let tol = this.computedSum(values)
                          result = Math.round(tol * 100) / 100
                          break
                      }
                      result = String(result)
                      const dot = result.indexOf('.')
                      if (dot > -1)
                      {
                        result = result.slice(0, dot + 3)
                      }
                    }
                    // this.totalData.push(result)
                    this.totalData[0][it.fieldname] = result
                  } else
                  {
                    if (it.gridwith && it.gridwith != 0)
                    {
                      // this.totalData.push('')
                      this.totalData[0][it.fieldname] = ''
                    }
                  }
                }
              })
              // console.log(this.totalData, 'this.totalData');
            }
            this.ini = JSON.parse(JSON.stringify(this.tableData))
            this.ini2 = JSON.parse(JSON.stringify(this.totalData))
          }
        }
      })
    },
    // 显示处理异常列表
    checkUrlToGo (row) {
      this.errorRow = row
      this.showJumpPicker = true
    },
    // 联升放行
    b4lianShengFX (row) {
      if (!this.v8apitoken)
      {
        getDynV8ApiToken().then(res => {
          // 获取v8apitoken 后面自定义接口用到
          this.v8apitoken = res
          this.lianShengFX(row)
        })
      } else
      {
        this.lianShengFX(row)
      }
    },
    lianShengFX (row) {
      getReq(
        {
          autoid: 0,
          fixcode: '990da54a9a734dab86403f4f4cc4a863',
          p01: row.autoid
        },
        this.v8apitoken
      ).then(res => {
        this.getAllPageDatas(this.param)
      })
    },
    // 选择处理异常回调
    onJumpPickerConfirm (val) {
      let url = val.url
      let ls = url.split('{')
      ls = ls.filter(it => {
        return it.indexOf('}') != -1
      })
      let keys = ls.map(it => {
        return it.split('}')[0]
      })
      keys.forEach(el => {
        const lab = '{' + el + '}'
        if (this.errorRow[el])
        {
          url = url.replace(lab, this.errorRow[el])
        } else
        {
          url = url.replace(lab, '')
        }
      })
      // console.log(url, 'url11url11');
      if (url)
      {
        if (val.type == 0)
        {
          // 存储本页面路由参数--用于跳转回此页面
          let obj = this.$route.query
          obj.param = this.param
          sessionStorage.setItem(
            'commHrQueryPageSetRouteData',
            JSON.stringify(obj)
          )
          // 跳转路由
          this.$router.push(url + '&fromPage=commHrQueryPage')
        } else
        {
          // 跳转网址
          const u = navigator.userAgent
          const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
          const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
          if (isAndroid)
          {
            //android终端
            window.open(url, '_blank')
          } else if (isiOS)
          {
            //ios终端
            window.location.href = url
          } else
          {
            window.open(url, '_blank')
          }
        }
      } else
      {
        Toast.fail('未设置地址！')
      }
      this.showJumpPicker = false
    },
    // 点击选择某个月份
    getOneMonth (v) {
      if (this.checkedMonth == v && false)
      {
        this.checkedMonth = ''
        this.param = ''
        // 查询页面
        this.getAllPageDatas(this.param)
      } else
      {
        this.checkedMonth = v
        if (this.checkedYear)
        {
          this.param = this.checkedYear + '' + this.add0(this.checkedMonth)
          // 查询页面
          this.getAllPageDatas(this.param)
        }
      }
    },
    // 点击选择某个年份
    getOneYear (v) {
      if (this.checkedYear == v && false)
      {
        this.checkedYear = ''
        this.param = ''
        // 查询页面
        this.getAllPageDatas(this.param)
      } else
      {
        this.checkedYear = v
        if (this.showMonths)
        {
          if (this.checkedMonth)
          {
            this.param = this.checkedYear + '' + this.add0(this.checkedMonth)
            // 查询页面
            this.getAllPageDatas(this.param)
          }
        } else
        {
          this.param = this.checkedYear + ''
          // 查询页面
          this.getAllPageDatas(this.param)
        }
      }
    },
    // 箭头切换年份
    arrowsYear (v) {
      if (v == 'left')
      {
        this.years.unshift(this.years[0] - 1)
        this.years.pop()
      } else
      {
        this.years.push(this.years[2] + 1)
        this.years.shift()
      }
    },
    // 根据日期获取年份列表
    getYearsByDate (v) {
      if (v)
      {
        let date = new Date(v)
        let year = date.getFullYear()
        this.years = [year - 1, year, year + 1]
        //
        this.checkedYear = year
      }
    },
    // 平均值
    computedAverage (arr) {
      return Math.floor((sum(arr) * 1000) / arr.length) / 1000
    },
    // 整数
    computedCount (arr) {
      return arr.length
    },
    // 最大值
    computedMax (arr) {
      return Math.max(...arr)
    },
    // 最小值
    computedMin (arr) {
      return Math.min(...arr)
    },
    // 求和
    computedSum (arr) {
      return arr.reduce((prev, curr) => {
        const value = Number(curr)
        if (!isNaN(value))
        {
          return prev + curr
        } else
        {
          return prev
        }
      }, 0)
    },
    onConfirm (value) {
      this.showCalendar = false
      this.getMonDayAndSunDay(value)
      this.checkdate = value.getDate()
      this.checkFullDate = this.formatDate(value, 'yyyy-MM-dd')
      this.param = this.formatDate(this.checkFullDate, 'yyyyMMdd')
      // 查询页面
      this.getAllPageDatas(this.param)
    },
    resetSign () {
      this.$refs.hrQuerySignaturePad.clear()
    },
    onSearch (val) {
      if (val)
      {
        this.tableData = this.ini.filter(item => {
          let has = false
          this.thList.forEach(it => {
            if (it.fieldname != 'serial')
            {
              if (item[it.fieldname])
              {
                if (item[it.fieldname].toString().indexOf(val) > -1)
                {
                  has = true
                }
              }
            }
          })
          return has
        })
        this.totalData = []
      } else
      {
        this.tableData = JSON.parse(JSON.stringify(this.ini))
        this.totalData = JSON.parse(JSON.stringify(this.ini2))
      }
    }
  }
}
</script>

<style scoped lang="less">
// 签名弹窗
.hrQuery_signature_PopUp {
  // z-index: 99999;
  .wrapper {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .pop_body {
      width: 96%;
      height: auto;
      max-height: 85%;
      overflow-y: auto;
      border-radius: 30px 30px 0 0;
      background: #ffffff;
      .hb {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .nosign_title {
        .signTitle {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 28px;
          color: #666;
          height: 60px;
          padding-left: 3%;
          padding-right: 4%;
        }
        .signExplain {
          width: 100%;
          margin-bottom: 20px;
          word-break: break-all;
          color: #333;
          font-size: 24px;
          padding-left: 3%;
          padding-right: 4%;
          color: blue;
          text-align: justify;
        }
      }
      .annex_body {
        border-top: 2px solid #ccc;
        margin: 0 20px 20px 20px;
        .title {
          padding: 10px;
          display: flex;
          align-items: center;
          .title_txt1 {
            font-size: 32px;
          }
        }
      }
    }
    .signFooter {
      border-radius: 0 0 30px 30px;
      background: #ffffff;
      height: 90px;
      width: 96%;
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      justify-content: center;
      border-top: 1px solid #ccc;
      // margin-top: 20px;
      .button_can {
        width: 50%;
        text-align: center;
        border-right: 1px solid #ccc;
        color: #999;
        font-size: 28px;
        height: 100%;
        line-height: 90px;
      }
      .button_def {
        width: 50%;
        text-align: center;
        font-size: 28px;
        color: #2b8df0;
        height: 100%;
        line-height: 90px;
      }
    }
  }
}

// 反馈意见弹窗
.FeedbackPop {
  height: 80%;
  width: 90%;
  .title {
    // color: #fff;
    height: 90px;
    padding: 20px 0;
    text-align: center;
    font-size: 36px;
    font-family: Source Han Sans CN;
  }
  .signExplain {
    width: 100%;
    margin-bottom: 20px;
    word-break: break-all;
    color: #333;
    font-size: 24px;
    padding-left: 3%;
    padding-right: 4%;
    color: blue;
    text-align: justify;
  }
  .reason {
    height: calc(100% - 200px);
    padding: 10px 20px;
    .van-field {
      height: 100%;
      border: 1px solid #ebedf0;
      /deep/.van-field__value {
        .van-field__body {
          height: 100%;
          .van-field__control {
            height: 100% !important;
          }
        }
      }
    }
  }
  .footer {
    width: 100%;
    height: 100px;
    position: absolute;
    left: 0;
    bottom: 0;
    font-size: 32px;
    display: flex;
    justify-content: center;
    div {
      height: 80px;
      line-height: 80px;
      width: 80%;
      text-align: center;
      background: #2b8df0;
      color: #fff;
      font-size: 36px;
      border-radius: 12px;
    }
  }
}
//  协议弹窗
.salaryAgreePop {
  height: 80%;
  width: 90%;
  .title {
    // color: #fff;
    height: 90px;
    padding: 20px 0;
    text-align: center;
    font-size: 36px;
    font-family: Source Han Sans CN;
  }
  .content {
    height: calc(100% - 200px);
  }
  .footer {
    width: 100%;
    height: 100px;
    position: absolute;
    left: 0;
    bottom: 0;
    font-size: 32px;
    display: flex;
    border-top: 1px solid #ebedf0;
    .arg1 {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #247dff;
      line-height: 100px;
      border-right: 1px solid #ebedf0;
    }
    .arg2 {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ee0a24;
      line-height: 100px;
    }
  }
}
.queryDetails {
  height: 100%;
  overflow: hidden;
  // background: #eceaea;
  .van-nav-bar {
    background: #2b8df0;
    /deep/ .van-nav-bar__left {
      .van-nav-bar__text {
        color: #ffffff;
        font-size: 36px;
      }
      .van-icon {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
    ::v-deep .van-nav-bar__right {
      .van-tag {
        margin-right: 24px;
        font-size: 24px;
        .van-icon {
          color: #ffffff;
        }
      }
      .van-nav-bar__text {
        color: #fff;
        font-family: Source Han Sans CN;
      }
    }
  }
  .overflow_div {
    background: #f6f6f6;
    // overflow: auto;
    height: calc(100% - 92px);
    .date_content {
      .year_box {
        display: flex;
        align-items: center;
        padding: 20px 0;
        background: #ffffff;
        .icon_box {
          display: flex;
          align-items: center;
          .van-icon {
            font-size: 40px;
            font-weight: bold;
          }
        }
        .year_btn {
          width: calc((100% - 40px) / 3);
          color: #2a2a2a;
          font-size: 32px;
          font-weight: bold;
          text-align: center;
          background-color: #eff6ff;
          border-radius: 10px;
          .year {
            padding: 10px 0;
          }
        }
        .cao0 {
          margin: 0 20px 0 10px;
        }
        .cao1 {
          margin-right: 20px;
        }
        .cao2 {
          margin-right: 10px;
        }
        .checkd_year {
          color: #ffffff;
          background: #5398ff;
        }
      }
      .month_box {
        display: flex;
        flex-wrap: wrap;
        background: #ffffff;
        padding-bottom: 10px;
        .month_btn {
          width: calc(100% / 6);
          color: #aeaeae;
          font-size: 28px;
          text-align: center;
          .month {
            padding: 10px 0;
            margin: 10px;
          }
          .checkd_Month {
            color: #5095ff;
            background: #ffffff;
            border-radius: 30px;
            border: 1px solid #5095ff;
          }
        }
      }
      .date_box {
        .head_date {
          display: flex;
          align-items: center;
          padding: 20px 0;
          background: #fff;
          .icon_box {
            display: flex;
            align-items: center;
            .van-icon {
              font-size: 40px;
              font-weight: bold;
            }
          }
          .date_box {
            width: calc((100% - 40px) / 7);
            font-size: 28px;
            text-align: center;
            .week {
              margin-bottom: 10px;
            }
            .date {
              display: flex;
              justify-content: center;
              align-items: center;
              .text {
                width: 50px;
                height: 50px;
                line-height: 50px;
                border-radius: 50%;
              }
              .bgtext {
                color: #fff;
                background: #2b8df0;
              }
            }
          }
        }
      }
    }
    .table_content {
      .vue-table-root {
        /deep/.ve-table {
          height: 100%;
          .ve-table-container {
            .ve-table-content-wrapper {
              .ve-table-content {
                .ve-table-header {
                  .ve-table-header-tr {
                    height: 80px;
                    .ve-table-header-th {
                      font-size: var(--header_fontsize); // 28px;
                      font-weight: var(--header_isbold); // bold;
                      white-space: pre-wrap;
                    }
                  }
                }
                .ve-table-body {
                  .ve-table-body-tr {
                    .ve-table-body-td {
                      padding: 0 !important;
                    }
                    .merged-cell {
                      div {
                        display: flex;
                        justify-content: center;
                      }
                    }
                  }
                }
                .ve-table-footer {
                  .ve-table-footer-tr {
                    height: 80px;

                    .ve-table-footer-td {
                      font-size: 28px;
                      background-color: rgb(255, 211, 184);
                    }
                  }
                }
              }
            }
          }
        }
      }
      .auto_table {
        height: 100%;
        overflow: auto;
        .table {
          width: 100%;
          border-spacing: 0px;
          tr {
            td:nth-child(1) {
              border-left: 2px solid #dcdfe6;
            }
            th,
            td {
              padding: 6px 10px;
              text-align: center;
              border-bottom: 2px solid #dcdfe6;
              border-right: 2px solid #dcdfe6;
              .comm_box {
                .boolean_box {
                  .van-checkbox {
                    justify-content: center;
                    /deep/.van-checkbox__icon--checked {
                      .van-icon {
                        color: #fff !important;
                        background-color: #1989fa !important;
                        border-color: #1989fa !important;
                      }
                    }
                    /deep/.van-checkbox__icon--disabled .van-icon {
                      background-color: #fff;
                    }
                  }
                }
              }
            }
          }
          .top {
            position: sticky;
            top: 0;
            font-size: 28px;
            background: #e9f3fd;
            height: 64px;
            th:nth-child(1) {
              border-left: 2px solid #dcdfe6;
            }
          }
          .cont {
            height: 64px;
            font-size: 24px;
          }
          .cont:nth-child(2n-1) {
            background: #f5f5f5;
          }
        }
      }
    }
    .form_content {
      position: relative;
      .userInfoRight {
        position: absolute;
        top: 160px;
        right: 0.42667rem;
        display: flex;
        align-items: center;
        z-index: 9999;
        .svg_sigin {
          width: 130px;
          height: 130px;
          margin-right: 10px;
          .svg-icon {
            width: 100%;
            height: 100%;
          }
        }
      }
      /deep/.van-collapse {
        height: 100%;
        overflow-y: auto;
        .van-collapse-item {
          margin: 20px;
          .van-collapse-item__title {
            border-radius: 20px 20px 0 0;
            .van-cell__title {
              font-size: 32px;
              font-weight: bold;
              font-family: Source Han Sans CN;
              color: #000;
              .title_bg {
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                img {
                  height: 100%;
                }
              }
              .xiba_title {
                display: flex;
                align-items: center;
                position: relative;
                .van-icon {
                  margin-right: 16px;
                }
              }
            }
          }
          .van-collapse-item__wrapper {
            border-radius: 0 0 20px 20px;
            .van-collapse-item__content {
              .peField {
                .van-cell {
                  .van-cell__label {
                    color: #aeaeae;
                    width: 8em;
                  }
                  .van-cell__value {
                    color: #2a2a2a;
                    text-align: left;
                  }
                }
                .van-field {
                  .van-field__label {
                    color: #aeaeae;
                    width: 8em;
                  }
                  .van-field__value {
                    color: #2a2a2a;
                  }
                }
                .not_canedi {
                  .van-field__value {
                    .van-field__body {
                      .van-field__control {
                        color: #2a2a2a;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      .van-hairline--top-bottom::after {
        border: unset;
      }
      .noGroup_box {
        height: 100%;
        overflow-y: auto;
        .noGroup_form {
          padding: 0 50px;
          background-color: #fff;
          .peField {
            .van-field {
              .van-field__label {
                color: #aeaeae;
                width: 8em;
              }
              .van-field__value {
                color: #2a2a2a;
              }
            }
          }
        }
      }
    }
  }

  .has_feedback {
    position: relative;
    // z-index: 9999;
    height: 132px;
    width: 100%;
    padding: 0 20px;
    background: #fff;
    display: flex;
    justify-content: space-around;
    align-items: center;
    gap: 20px;
    .onlyOneBtn {
      width: 90% !important;
    }
    .has_feedback_btn1,
    .has_feedback_btn2 {
      height: 90px;
      text-align: center;
      line-height: 90px;
      color: #fff;
      font-size: 32px;
      border-radius: 12px;
      flex: auto;
    }
    .has_feedback_btn1 {
      // width: 40%;
      // width: 30%;
      // background: rgb(255, 174, 201);
      background: #2b8df0;
    }
    .has_feedback_btn2 {
      // width: 40%;
      // width: 30%;
      background: #2b8df0;
    }
  }
}
</style>
